/* src/app/timecard/time-card-documentation-presenter/time-card-documentation-presenter.component.scss */
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content {
  height: calc(100vh - 150px);
  width: 100%;
  overflow: hidden;
  font-size: 1.5em;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .tabulator {
  overflow: visible;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-table {
  table-layout: fixed !important;
  width: 100% !important;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-scrollable-header table,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-scrollable-body table {
  table-layout: fixed !important;
  width: 100% !important;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-thead > tr > th.work-date-cell,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-tbody > tr > td.work-date-cell {
  width: 5rem !important;
  min-width: 5rem !important;
  max-width: 5rem !important;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-thead > tr > th.time-doc-hours-cell,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-tbody > tr > td.time-doc-hours-cell,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-thead > tr > th.doc-hours-cell,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .timecard-doc-table .p-datatable-tbody > tr > td.doc-hours-cell {
  width: 2.5rem !important;
  min-width: 2.5rem !important;
  max-width: 2.5rem !important;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 4em;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header .p-datatable-thead > tr > th {
  position: sticky;
  top: -1em;
  z-index: 99;
  font-size: 1em;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell {
  min-height: 21px;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell.tabulator-cell-empty,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell.table-cell-empty {
  margin: 0;
  padding: 0;
  border: none;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell .tabulator-cell-empty,
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell .table-cell-empty {
  margin: 0;
  padding: 0;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell .p-dropdown-label-container {
  min-height: 1.5em;
}
body#themeTag :host ::ng-deep .timecard-doc-accordion .p-accordion-content .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-body .p-datatable-tbody .p-datatable-cell .p-inputtext {
  min-height: 1.85em;
}
body#themeTag :host ::ng-deep .p-fileupload {
  font-size: 1em;
}
body#themeTag :host ::ng-deep .p-fileupload .p-button.p-component.p-fileupload-choose > .p-button-icon {
  font-size: 1em;
}
body#themeTag :host ::ng-deep .p-fileupload .p-messages {
  zoom: 0.5;
}
body#themeTag :host ::ng-deep .p-fileupload .p-messages .p-message {
  margin-top: 50px;
}
body#themeTag :host ::ng-deep .p-fileupload .p-messages .p-message .p-message-summary {
  zoom: 2;
}
body#themeTag :host ::ng-deep p-celleditor {
  width: 100%;
}
/*# sourceMappingURL=time-card-documentation-presenter.component.css.map */
